import { ProductConfiguration } from '@storefront/types/Product';
import { getUIDBySKU } from '@storefront/utils/prodRequests';

import { isZeroDollarPaperPlan } from '../../utils/utils';
import {
  BundleItemOptionWithLowestPrice,
  BundleItemWithLowestPrice,
  BundleProductWithLowestPrice,
} from '../product-configuration.utils';

const checkIfZeroDollarPaperPlan = (
  bundleOption: BundleItemWithLowestPrice,
  zeroDollarPaperPlanCase: boolean
) =>
  zeroDollarPaperPlanCase ? bundleOption.options[1] : bundleOption.options[0];

export const getOptionToShow = (
  bundleOption: BundleItemWithLowestPrice,
  configuration: ProductConfiguration,
  activeSKU: string,
  bundleProduct: BundleProductWithLowestPrice
) => {
  const zeroDollarPaperPlanCase = isZeroDollarPaperPlan(bundleOption);

  /// each paper plan has a required sku that corresponds to one II plan . We are filtering the PP without required sku
  const requiredSkus = bundleOption.options
    ?.map((option) => option.required_sku)
    .filter((sku) => sku !== '');
  /// Gets the Uid of the II plan that corresponds to the required sku of the paper plan
  const parentOptionUidThatRequiresSku = requiredSkus.map((sku) =>
    getUIDBySKU(bundleProduct, sku)
  );

  let optionToShow = {} as BundleItemOptionWithLowestPrice;
  if (activeSKU && configuration?.[activeSKU]) {
    const selectedValues = Object?.values(configuration?.[activeSKU]);
    if (selectedValues?.length > 0) {
      const someRequiredSkusSelected = parentOptionUidThatRequiresSku.some(
        (uid) => selectedValues.includes(uid)
      );
      if (someRequiredSkusSelected) {
        /// shows the paper plan correspondent to the II plan selected
        const requiredSkuSelectedIndex =
          parentOptionUidThatRequiresSku.findIndex((uid) =>
            selectedValues.includes(uid)
          );
        /// if we have a zero dollar paper plan we should not consider it as a valid option
        optionToShow = zeroDollarPaperPlanCase
          ? bundleOption.options[requiredSkuSelectedIndex + 1]
          : bundleOption.options[requiredSkuSelectedIndex];
      } else {
        /// user did not selected II still no pre selection / target state case
        optionToShow = checkIfZeroDollarPaperPlan(
          bundleOption,
          zeroDollarPaperPlanCase
        );
      }
    }
  } else {
    /// no pre selection / target state case
    optionToShow = checkIfZeroDollarPaperPlan(
      bundleOption,
      zeroDollarPaperPlanCase
    );
  }
  return optionToShow;
};
